/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type ApprovalFilterEnum =
  (typeof ApprovalFilterEnum)[keyof typeof ApprovalFilterEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApprovalFilterEnum = {
  All: 0,
  AutoApproved: 1,
  ManuallyApproved: 2,
  NotYetApproved: 3,
} as const;
